import { types } from 'mobx-state-tree';
import { Shape } from './shape-model';

export const FigureElement = Shape.named('FigureElement')
  .props({
    type: types.optional(types.string, 'figure'),
    subType: types.optional(types.string, 'rect'),
    fill: types.optional(types.string, '#BFBFBF'),
    dash: types.optional(types.array(types.number), []),
    strokeWidth: types.optional(types.number, 0),
    stroke: types.optional(types.string, ''),
    cornerRadius: types.optional(types.number, 0),
    pathData: types.optional(types.string, ''),
  })
  .preProcessSnapshot((snapshot) => {
    if (!snapshot) return snapshot;
    const s = { ...snapshot };
    const numericKeys = ['strokeWidth', 'cornerRadius'];
    numericKeys.forEach((key) => {
      if (key in s && typeof s[key] === 'string') {
        s[key] = parseFloat(s[key]) || 0;
      }
    });
    return s;
  });
